mutation RetryFailedEmail($payload: FailedEmailRetryInput!) {
    failedEmailRetry(input: $payload) {
        email {
            id
        }
    }
}
